import { getField } from "vuex-map-fields";

const family = (state) => state.family;

const mainCustomer = (state) => state.family.main.data;

const partner = (state) => ("partner" in state.family ? state.family.partner.data : null);

const children = (state) => ("children" in state.family ? state.family.children.data : null);

const activeFilterCount = (state) => [
  ...Object.values(state.filter.policies.mutation_codes),
  ...Object.values(state.filter.packages.mutation_codes),
].reduce((a, b) => a + (b === true ? 0 : 1), 0);

const inactivePackages = (state) => {
  if (state.activeCustomerId && state.activeCustomerId in state.inactivePackages) {
    return state.inactivePackages[state.activeCustomerId];
  }
  return [];
};

const activePackages = (state) => {
  if (state.activeCustomerId && state.activeCustomerId in state.activePackages) {
    return state.activePackages[state.activeCustomerId];
  }
  return [];
};

const policies = (state) => {
  if (state.activeCustomerId && state.activeCustomerId in state.policies) {
    return state.policies[state.activeCustomerId];
  }
  return [];
};

const familyArray = (state, getters) => {
  if (state.family === null) return [];
  let customers = [];
  customers.push(getters.mainCustomer);
  if (getters.partner) customers.push(getters.partner);
  if (getters.children) customers = [...customers, ...getters.children];

  return customers;
};

const policyTableHeaders = (state) => state.policyTableHeaders;

const packagesFilter = (state) => state.filter.packages.mutation_codes;
const policiesFilter = (state) => state.filter.policies.mutation_codes;

const allPackagesFilterActive = (state, getters) => Object.values(getters.packagesFilter)
  .every((item) => item === false);

const allPoliciesFilterActive = (state, getters) => Object.values(getters.policiesFilter)
  .every((item) => item === false);

const packagesFilterActive = (state, getters) => Object.values(getters.packagesFilter)
  .some((value) => value === false);

const policiesFilterActive = (state, getters) => Object.values(getters.policiesFilter)
  .some((value) => value === false);

export default {
  allPoliciesFilterActive,
  allPackagesFilterActive,
  packagesFilterActive,
  policiesFilterActive,
  inactivePackages,
  activePackages,
  activeFilterCount,
  family,
  policies,
  partner,
  mainCustomer,
  children,
  familyArray,
  policyTableHeaders,
  packagesFilter,
  policiesFilter,
  getField,
};
